import React from 'react'
import { Link } from 'react-router-dom'

const PageNotFound = () => {
    return (
        <div className='pageNotFound w-100 '>
            <div className="row align-items-center w-100 h-100">
                <div className="text-center pt-5">
                    <h1>404</h1>
                    <p>Page Not Found</p>
                    <p>Sorry,we were unable to find that page</p>
                    <Link to={'/'} className='d-block'>Back to Login</Link>
                    <img src={`${process.env.REACT_APP_SECOND_CAREERS_CDN}not found.png`} alt="page not found" />
                </div>
            </div>
        </div>
    )
}

export default PageNotFound